module.exports = __webpack_public_path__ + "static/media/section_7_banner.56f74dc7.svg";